"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.chains = exports.ChainId = exports.ChainName = void 0;
var chains_1 = require("./chains");
Object.defineProperty(exports, "chains", { enumerable: true, get: function () { return chains_1.chains; } });
var enums_1 = require("./enums");
Object.defineProperty(exports, "ChainName", { enumerable: true, get: function () { return enums_1.ChainName; } });
Object.defineProperty(exports, "ChainId", { enumerable: true, get: function () { return enums_1.ChainId; } });
var getById = function (id) { return chains_1.chains[id]; };
var getByName = function (name) {
    return Object.values(chains_1.chains).find(function (chain) { return chain.name === name; }) || {};
};
var get = function (idOrName) {
    return typeof idOrName === 'number' ? getById(idOrName) : getByName(idOrName);
};
exports.default = {
    getById: getById,
    getByName: getByName,
    get: get
};
